import { MapPin, ArrowRight, CheckCircle2 } from "lucide-react";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import MobileStickyBar from "@/components/MobileStickyBar";
import Seo, { businessSchema } from "@/components/seo/Seo";

const sectors = [
  "Dombes et Val de Saône",
  "Villefranche-sur-Saône et Beaujolais sud",
  "Métropole de Lyon et nord lyonnais",
  "Bourg-en-Bresse et secteur de l'Ain selon projet",
];

export default function ZonesInterventionPage() {
  return (
    <div className="min-h-screen bg-[#0284FC]">
      <Seo
        title="Zones d'intervention Vinylux | Ain, Lyon, Villefranche-sur-Saône"
        description="Vinylux intervient pour la rénovation de cuisine par covering dans l'Ain, la Dombes, le Val de Saône, Villefranche-sur-Saône, Lyon et alentours."
        path="/zones-intervention"
        schema={businessSchema}
      />
      <Navigation />
      <main className="pb-20 lg:pb-0">
        <section className="pt-32 lg:pt-[180px] pb-16 bg-[#0284FC] text-white">
          <div className="max-w-6xl mx-auto px-6 sm:px-8 lg:px-12">
            <div className="inline-flex items-center gap-2 bg-white/15 px-4 py-1.5 rounded-full text-sm font-semibold mb-6">
              <MapPin className="w-4 h-4" /> Zones d'intervention
            </div>
            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter max-w-4xl mb-6">Vinylux intervient dans l'Ain, le Rhône et les secteurs voisins</h1>
            <p className="text-lg text-white/80 leading-relaxed max-w-3xl">Basé à Sainte-Olive, Vinylux se déplace pour des projets de rénovation de cuisine par covering. La faisabilité et le déplacement sont confirmés au moment du devis.</p>
          </div>
        </section>

        <section className="bg-[#0877D8] py-14 lg:py-20">
          <div className="max-w-6xl mx-auto px-6 sm:px-8 lg:px-12 grid lg:grid-cols-2 gap-6">
            <a href="/covering-cuisine-ain" className="group rounded-3xl bg-white/10 border border-white/15 p-8 hover:bg-white/15 transition-colors">
              <div className="text-white/65 text-sm font-semibold mb-3">Secteur Ain</div>
              <h2 className="font-heading text-3xl font-black text-white mb-4">Covering cuisine dans l'Ain</h2>
              <p className="text-white/75 leading-relaxed mb-6">Dombes, Val de Saône, Bourg-en-Bresse et communes de l'Ain selon la taille et la nature du chantier.</p>
              <span className="inline-flex items-center gap-2 text-white font-bold">Voir la page Ain <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" /></span>
            </a>
            <a href="/covering-cuisine-lyon" className="group rounded-3xl bg-white/10 border border-white/15 p-8 hover:bg-white/15 transition-colors">
              <div className="text-white/65 text-sm font-semibold mb-3">Secteur Rhône</div>
              <h2 className="font-heading text-3xl font-black text-white mb-4">Covering cuisine à Lyon et alentours</h2>
              <p className="text-white/75 leading-relaxed mb-6">Lyon, nord lyonnais, Villefranche-sur-Saône et communes voisines selon le projet.</p>
              <span className="inline-flex items-center gap-2 text-white font-bold">Voir la page Lyon <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" /></span>
            </a>
          </div>
        </section>

        <section className="bg-white py-16 lg:py-20">
          <div className="max-w-5xl mx-auto px-6 sm:px-8 lg:px-12">
            <h2 className="font-heading text-3xl sm:text-4xl font-black tracking-tight text-[#053B63] mb-8">Principaux secteurs couverts</h2>
            <div className="grid sm:grid-cols-2 gap-4">
              {sectors.map((sector) => (
                <div key={sector} className="flex items-start gap-3 p-5 rounded-2xl bg-slate-50 border border-slate-100">
                  <CheckCircle2 className="w-5 h-5 text-[#168BFF] mt-0.5 shrink-0" />
                  <span className="font-semibold text-slate-700">{sector}</span>
                </div>
              ))}
            </div>
            <div className="mt-10 rounded-3xl bg-[#053B63] p-8 sm:p-10 text-white flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
              <div>
                <h3 className="font-heading text-2xl font-black mb-2">Votre commune n'est pas dans la liste ?</h3>
                <p className="text-white/70">Envoyez simplement votre localisation et quelques photos de la cuisine. Je vous dirai si le déplacement est cohérent.</p>
              </div>
              <a href="/contact" className="shrink-0 bg-[#168BFF] hover:bg-[#0f7de9] text-white font-bold px-6 py-3 rounded-full">Demander un devis</a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <MobileStickyBar />
    </div>
  );
}
